"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledBaseChip = exports.Color = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
var _getColorBackground = require("./utils/getColorBackground");
var _getColorBorder = require("./utils/getColorBorder");
var _getColorBoxShadow = require("./utils/getColorBoxShadow");
const StyledBaseChip = exports.StyledBaseChip = (0, _mui.styled)(_mui.Chip)((props)=>{
    var _props_height;
    return {
        height: (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : _constants.OPTION_HEIGHT,
        ...props.selected && {
            '&&': {
                backgroundColor: props.theme.palette.primary.main,
                [".".concat(_mui.typographyClasses.root)]: {
                    color: props.theme.palette.text.primary
                }
            }
        },
        ["&.".concat(_mui.chipClasses.deletable)]: {
            paddingRight: props.theme.spacing(1)
        }
    };
});
const Color = exports.Color = (0, _mui.styled)('div')((param)=>{
    let { selected, hexColors, theme, iconSize, selectedIconSize } = param;
    const background = (0, _getColorBackground.getColorBackground)({
        hexColors,
        theme
    });
    const border = (0, _getColorBorder.getColorBorder)({
        background,
        theme
    });
    const style = {
        background,
        backgroundSize: 'cover',
        border,
        borderRadius: '50%',
        boxSizing: 'border-box',
        display: 'flex',
        height: iconSize !== null && iconSize !== void 0 ? iconSize : _constants.COLOR_ICON_SIZE,
        position: 'relative',
        width: iconSize !== null && iconSize !== void 0 ? iconSize : _constants.COLOR_ICON_SIZE
    };
    if (selected) {
        style.height = selectedIconSize !== null && selectedIconSize !== void 0 ? selectedIconSize : _constants.SELECTED_COLOR_ICON_SIZE;
        style.width = selectedIconSize !== null && selectedIconSize !== void 0 ? selectedIconSize : _constants.SELECTED_COLOR_ICON_SIZE;
        style.border = "1px solid ".concat(theme.palette.common.black);
        style['&::before'] = {
            border: '0px solid transparent',
            borderRadius: '50%',
            boxShadow: "inset 0 0 0 3px ".concat((0, _getColorBoxShadow.getColorBoxShadow)({
                background,
                theme
            })),
            content: '""',
            display: 'block',
            height: 'calc(100% + 1px)',
            position: 'absolute',
            width: 'calc(100% + 1px)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };
    }
    return style;
});
